/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} North_Last_Blackbird_SparkInputs */

const fr_north_last_blackbird_spark = /** @type {(inputs: North_Last_Blackbird_SparkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous modifier votre mot de passe, vous serez deconnecté et vous devrez vous réauthentifier avec votre nouveau mot de passe.`)
};

/**

* @param {North_Last_Blackbird_SparkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const north_last_blackbird_spark = /** @type {((inputs?: North_Last_Blackbird_SparkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<North_Last_Blackbird_SparkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_north_last_blackbird_spark(inputs)
});